import { render, staticRenderFns } from "./DisbursementInputTypeInput.vue?vue&type=template&id=a05c57e2&"
import script from "./DisbursementInputTypeInput.vue?vue&type=script&lang=js&"
export * from "./DisbursementInputTypeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput})
